module.exports = __webpack_public_path__ + "img/csv.e253a55d.png";